import axios from 'axios'
import aes256 from 'aes256'

const url = 'https://www.api.mathis-figuet.com/api/'

export default {
  getApplications (credentials) {
    return axios
      .post(url + 'userApplications/', credentials)
      .then(response => response.data)
  },
  updateApplication (credentials) {
    return axios
      .post(url + 'updateApplication/', credentials)
      .then(response => response.data)
  },
  addApplication (credentials) {
    return axios
      .post(url + 'application/', credentials)
      .then(response => response.data)
  },
  deleteApplication (credentials) {
    return axios
      .post(url + 'deleteApplication/', credentials)
      .then(response => response.data)
  },
  encryptContent (key, application) {
    const temp = {
      id_application: application.id_application,
      login: aes256.encrypt(key, application.login),
      password: aes256.encrypt(key, application.password),
      url: aes256.encrypt(key, application.url),
      description: aes256.encrypt(key, application.description),
      id_user: application.id_user
    }
    return temp
  },
  decryptContent (key, application) {
    const temp = {
      id_application: application.id_application,
      login: aes256.decrypt(key, application.login),
      password: aes256.decrypt(key, application.password),
      url: aes256.decrypt(key, application.url),
      description: aes256.decrypt(key, application.description),
      id_user: application.id_user
    }
    return temp
  }
}
